import { combineEpics, ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { IdPersistence } from "../../constants/IdPersistence";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../utils/network/generated/protoTypes";
import { PersistenceMode } from "../../utils/PersistenceMode";
import { utilPersistence } from "../../utils/utilPersistence";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionFacebookConnect, actionFacebookConnected, actionFacebookDifferentPlayerConnected, TypeActionFacebook, } from "./actionFacebookConnect";
import { pathHandleFbConnectError } from "./pathHandleFbConnectError";
var epicFacebookConnectRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionFacebook.Connect), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectPlayerInfo(state).playerId;
        var credentials = getCredentials();
        return deps
            .netSend({
            id: CommandCode.FacebookConnect,
            props: {
                accessToken: credentials.fbToken,
                authToken: credentials.loginToken,
                playerId: playerId,
                playerIdToConnect: playerId,
            },
        })
            .pipe(switchMap(function (res) {
            utilPersistence.setValue(IdPersistence.FbConnected, true, PersistenceMode.Write);
            return of(actionFacebookConnected());
        }));
    }), catchError(function () {
        return pathHandleFbConnectError();
    }));
};
var epicFacebookRequestInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionFacebook.RequestInfo), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectPlayerInfo(state).playerId;
        var credentials = getCredentials();
        return deps.netSend({
            id: CommandCode.FacebookConnectInfo,
            props: {
                accessToken: credentials.fbToken,
                authToken: credentials.loginToken,
                playerId: playerId,
            },
        });
    }), switchMap(function (res) {
        var state = state$.value;
        var playerId = selectPlayerInfo(state).playerId;
        var serverConnectedPLayerId = res.connectedPlayer && res.connectedPlayer.id ? res.connectedPlayer.id : undefined;
        // player connected to fb account is current player
        if (serverConnectedPLayerId === undefined ||
            playerId.equals(serverConnectedPLayerId)) {
            return of(actionFacebookConnect());
        }
        // player connected to fb account is not current player
        return from([
            actionFacebookDifferentPlayerConnected(res),
            actionModalOpen(IdModal.FacebookConnectAnotherPlayerConnected),
        ]);
    }), catchError(function (error) {
        utilPersistence.setValue(IdPersistence.FbConnected, false, PersistenceMode.Write);
        return pathHandleFbConnectError();
    }));
};
var getCredentials = function () {
    return utilPersistence.getValue(IdPersistence.Credentials, {});
};
export var epicFacebookConnect = combineEpics(epicFacebookConnectRequest, epicFacebookRequestInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/epicFacebookConnect.ts
// module id = 1852
// module chunks = 3